import React from 'react'
import { Button, Col, Modal, Row } from 'react-bootstrap'
import { MdDeleteOutline } from "react-icons/md"
import UseDeleteOneItemCart from '../../CustomHooks/Cart/UseDeleteOneItemCart'
import UseUpdateCartItem from '../../CustomHooks/Cart/UseUpdateCartItem'
import DeletePopUp from '../Layout/DeletePopUp'
import { FaStar } from "react-icons/fa";

const CartItem = ({ item }) => {
  const [handleDeleteOneItem, deleteShow, handleDeleteShow, handleDeleteClose] = UseDeleteOneItemCart(item)
  const [handleChangeCountValue, countValue, ImageCover, CategoryName, ProductName, RatingAverage, BrandName] = UseUpdateCartItem(item)

  return (
    <Col xs="12" className="shadow mb-4 d-flex p-4">
      <DeletePopUp show={deleteShow} handleDeleteItem={handleDeleteOneItem} handleClose={handleDeleteClose} />
      {item.product != null ? (
        <Row className='w-100'>
          <Col xl={3} lg={4} md={4} sm={6}>
            <img src={ImageCover} alt="" className='w-100 h-200px me-3' />
          </Col>
          <Col xl={9} lg={8} md={8} sm={6}>
            <Row>
              <Col sm="12" className="d-flex flex-row justify-content-between align-items-center">
                <div className="d-inline pt-2 fs-30 fw-bold dark-color">
                  {ProductName}
                </div>
                <div className="d-inline pt-2 fs-30 fw-bold orange-color">{item ? item.price : null} EGP </div>
              </Col>
            </Row>
            <Row>
              <Col sm="12" className="d-flex flex-row justify-content-between align-items-center">
                <div className="d-inline fs-16 yellow-color fw-bold">{RatingAverage} <FaStar /></div>
              </Col>
            </Row>
            <Row>
              <Col sm="12" className="mt-1">
                <div className="d-inline gray-color">{BrandName} </div>
              </Col>
            </Row>
            <Row>
              <Col sm="12" className="mt-1 d-flex">
                <div
                  className="ms-2 border"
                  style={{ backgroundColor: item ? item.color : null }}></div>
              </Col>
            </Row>
            <Row>
              <Col sm="12" className=" d-flex flex-row justify-content-between">
                <div className="d-inline pt-2 d-flex">
                  <select onChange={handleChangeCountValue} className='form-control' value={countValue}>
                    <option value="0">Choose Quantity</option>
                    {Array.from({ length: 10 }, (_, index) => (
                      <option key={index + 1} value={index + 1}>
                        {index + 1}
                      </option>
                    ))}
                  </select>

                </div>
              </Col>
            </Row>
            <Row>
              <div className="d-flex pt-2 pointer-cursor">
                <div className="orange-color mt-3 d-inline " onClick={handleDeleteShow}>Delete</div>
              </div>
            </Row>
          </Col>
        </Row>) : ""}

    </Col>
  )
}

export default CartItem
